import { useCallback, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { PartnerCommitmentTranslations } from 'partner360/entities/partnerCompleteness'

import styles from './ValueTypeConfirmDialogContent.module.scss'

interface IProps {
  onConfirm: () => Promise<void>
  onClose: () => void
  errorTranslationKey?: string
  translationKey: string
  actualsValueType: string
}

export const ValueTypeConfirmDialogContent = ({
  onConfirm,
  onClose,
  errorTranslationKey,
  translationKey,
  actualsValueType,
}: IProps) => {
  const [isSaving, setIsSaving] = useState(false)
  const [hasSaveError, setHasSaveError] = useState(false)
  const replaceParams = useMemo(
    () => [
      {
        key: '{actualsValueType}',
        value: actualsValueType,
      },
    ],
    [actualsValueType]
  )

  const onAgreeClick = useCallback(async () => {
    setIsSaving(true)
    setHasSaveError(false)
    try {
      await onConfirm()
      onClose()
    } catch {
      setHasSaveError(true)
    } finally {
      setIsSaving(false)
    }
  }, [onClose, onConfirm])

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Translation text={`${translationKey}-title`} replaceParams={replaceParams} />
      </div>

      <div className={styles.text}>
        <Translation text={`${translationKey}-text`} replaceParams={replaceParams} />
      </div>

      {hasSaveError && (
        <div className={styles.error}>
          <Translation
            text={errorTranslationKey || PartnerCommitmentTranslations.ExportMetricSaveError}
          />
        </div>
      )}
      <div className={styles.buttonsWrapper}>
        <Button onClick={onClose} variant={'outlined'} disabled={isSaving}>
          <Translation text={`${translationKey}-cancel`} />
        </Button>
        <Button onClick={onAgreeClick} className={styles.saveButton} loading={isSaving}>
          <Translation text={`${translationKey}-agree`} />
        </Button>
      </div>
    </div>
  )
}
